import { bus } from "@/main";

export default {
	name: "ButtonBlock",
	data() {
		return {
			isHover: false,
			value: null
		}
	},
	props: [
		"type",
		"label",
		"name",
		"validate",
	],
	created() {},
	watch: {
		"value": function() {
			this.returnForm();
		}
	},
	computed: {},
	methods: {
		returnForm() {
			bus.$emit(`loginForm${this.label}`, { "label": this.label, "value": this.value})
		}
	}
}



// WEBPACK FOOTER //
// ./src/components/blocks/input-block/input.block.js